/*@flow*/
import type { Node } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Fragment, useContext } from 'react';
import ResourceForm from './ResourceForm';
import humanize from 'underscore.string/humanize';
import BuilderContext from './Context';

type PropsT = {
  requestClosePortal: Function,
};

const Component = (o: PropsT): Node => {
  const ctx = useContext(BuilderContext);
  const { resourceName } = ctx.state;

  return (
    <Fragment>
      <div
        className="h3"
        css={css({ margin: '0 0 20px', textTransform: 'uppercase' })}
      >
        {humanize(resourceName)}{' '}
      </div>
      <a
        tabIndex={0}
        css={css({
          position: 'absolute',
          top: 5,
          right: 15,
          color: '#ccc',
        })}
        className="close"
        onClick={(e) => {
          e.preventDefault();
          o.requestClosePortal(true);
        }}
      >
        <i className="fa fa-times" />
      </a>
      <ResourceForm
        requestClosePortal={() => {
          o.requestClosePortal(false);
        }}
      />
    </Fragment>
  );
};

export default Component;
